
import axios, { Canceler } from 'axios';
import { ITagType } from '@/interfaces/Tags/ITagType';
import { ITag } from '@/interfaces/Tags/ITag';
const clientAPI = axios.create();

clientAPI.defaults.baseURL = process.env.VUE_APP_MYBASE_URL + '/api/';
clientAPI.defaults.headers.common['Cache-Control'] = 'no-cache, no-store, must-revalidate';
clientAPI.defaults.headers.common.Pragma = 'no-cache';
clientAPI.defaults.headers.common.Expires = '0';

export { clientAPI };
export default class API {

    //to get all nine tag
    public static async getTagType() 
    {
        const response = (await clientAPI.get('/tags/tagtype')).data;

        if (response.success) {
            return response.data as ITagType[];
        } else {
            throw new Error('Error getting app dashboard');
        }
    }

    //to get all tag data based on tagTypeId
    public static async getTags(tagTypeId:number)
    {
        const response = (await clientAPI.get('/tags/' + tagTypeId)).data;

        if (response.success) {
            return response.data as ITag[];
        } else {
            throw new Error(response.data);
        }
    }

    public static async getAllTags() {
        const response = (await clientAPI.get('/tags/all')).data;

        if (response.success) {
            return response.data as ITag[];
        } else {
            throw new Error(response.data);
        }
    }

    public static async posttag(savetag: any) {
        const result = (
            await clientAPI.post('tags/savetag', savetag)
        ).data;
        console.log(result);
        if (result.success) {
            return result.data as string;
        } else {
            throw new Error(result.errors);
        }
    }
    public static async updatetag(edittag: any) {
        const result = (
            await clientAPI.post('/tags/edittag', edittag)
        ).data;

        if (result.success) {
            return result.data as string;
        } else {
            throw new Error(result.errors);
        }
    }
    public static async deletetag(tagId: number) {
        const deleteResult = (await clientAPI.delete('tags/deletetag/' + tagId)).data;
        if (deleteResult.success) {
            return deleteResult.data as string;
        } else {
            throw new Error(deleteResult.errors);
        }
    }
}